var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalcao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 196,
    viewBox: "0 0 426 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.83 195.702H3.17338C1.51794 195.702 0.175598 194.36 0.175598 192.704V13.7839C0.175598 12.1285 1.51794 10.7861 3.17338 10.7861H422.83C424.482 10.7861 425.824 12.1285 425.824 13.7839V192.704C425.824 194.36 424.482 195.702 422.83 195.702Z",
    fill: "#DDE3E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.824 84.2332V132.176C425.824 135.491 423.14 138.168 419.829 138.168H6.17116C2.86028 138.168 0.175598 135.491 0.175598 132.176V84.2332C0.175598 80.9259 2.86028 78.2412 6.17116 78.2412H419.829C423.14 78.2412 425.824 80.9259 425.824 84.2332Z",
    fill: "#EFA73F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M425.824 112.491V132.176C425.824 135.491 423.14 138.168 419.829 138.168H6.17116C2.86028 138.168 0.175598 135.491 0.175598 132.176V112.491C0.175598 109.18 2.86028 106.499 6.17116 106.499H419.829C423.14 106.499 425.824 109.18 425.824 112.491Z",
    fill: "#EB8B2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.175598 25.8146H425.824V19.8047H0.175598V25.8146Z",
    fill: "#ABBAC3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.175598 45.9747H425.824V42.9697H0.175598V45.9747Z",
    fill: "#C3CDD5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.175598 174.97H425.824V171.965H0.175598V174.97Z",
    fill: "#C3CDD5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M423.19 20H2.8129C1.25956 20 0 18.7058 0 17.1132V3.7511C0 2.15501 1.25956 0.864258 2.8129 0.864258H423.19C424.744 0.864258 426 2.15501 426 3.7511V17.1132C426 18.7058 424.744 20 423.19 20Z",
    fill: "#EB8B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalcao);
export default __webpack_public_path__ + "static/media/balcao.8997514acc3acec6a3af3a5941de0771.svg";
export { ForwardRef as ReactComponent };